import { Button } from "@mui/material";

const Btn = ({ text, variant, color, fontSize, action, size, disabled }) => {
  return (
    <Button
      disabled={disabled || false}
      onClick={action}
      size={size || "small"}
      sx={{ fontSize: fontSize || 12 }}
      variant={variant || "contained"}
      color={color || "primary"}
    >
      {text || "button"}
    </Button>
  );
};

export default Btn;
